import { find } from 'lodash';
// Look for specific implementation with distributionType, fallback to generic one
export const findSlot = ({ adSlots, slotName, distributionType }) => find(adSlots, { name: slotName, distributionType }) ??
    find(adSlots, (current) => current.name === slotName && current.distributionType === undefined);
